<div #echarts echarts [options]="options" theme="macarons" class="h-[330px]"></div>